directivesObj